import type { ReactNode } from 'react';
import { WarningCircle } from '@phosphor-icons/react';

/**
 * Shared non-blocking amber caution banner. One visual family, three
 * callers in `message-bubble.tsx`: Truth Guard (FRONT-276, a bullet list of
 * unverifiable claims), the stall caution (FRONT-770, a bullet list of
 * stall reasons), and the give-up-on-reconnect notice (FRONT-773, a single
 * sentence). Pure presentational — the container markup (border/background/
 * icon/headline layout) is identical everywhere it appears; each caller
 * supplies its own body shape via `children`.
 */
export function AmberCautionBanner({
  headline,
  children,
}: {
  headline: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="max-w-[85%] rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-700 dark:text-amber-300">
      <div className="flex items-center gap-1.5 font-semibold">
        <WarningCircle size={13} weight="fill" />
        {headline}
      </div>
      {children}
    </div>
  );
}
